import { createContext } from 'react';

/**
 * بوابةُ الطفل تُنسِّق المعطَّل بـ`:disabled` في `kid.css` (لا تُمسّ) — فتحت `KidShell` يبقى
 * تعطيلُ `Button` بالسمة الأصلية، والغلافُ الثابت وحده هو ما تغيّر (جولة 26 سبتمبر 2026).
 */
export const NativeDisabledButtons = createContext(false);
